<template>
  <div class="schedule-cell-outer">
    <div class="schedule-cell-inner">
      <h5 class="a11y-hidden">프로야구 주간 일정(일, 주 단위)</h5>
      <div @click.prevent="(e)=>goWeek(e)">
        <swiper :options="swiperOptions" ref="dateListSwiper" class="swiper">
          <swiper-slide v-for="(kboDate, index) in dateList" :key="'month/date_' + index">
            <a href="#" @click.prevent="clickDate">
              <div class="day-of-week">{{kboDate.getDayOfWeekKor()}}</div>
              <div class="date-month">{{kboDate.getMonthDate()}}</div>
            </a>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import KboDate from '@/common/model/KboDate'
  export default {
    name: 'ScheduleSlider',
    props: {
      currentDate: {
        type: Date
      },
      changeFn: {
        type: Function
      }
    },
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        dateList: [],
        swiperOptions: {
          width: 952,
          height: 120,
          paginationClickable: true,
          spaceBetween: 0,
          slidesPerView: 7,
          // slidesPerGroup: 7,
          centeredSlides: true,
          // centeredSlidesBounds: true,
          // pagination: '.swiper-pagination',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
          }
      }
    },
    methods: {
      setDateListByMonth () {
        const kboDateList = []
        const { year, month } = this.currentDate.toObject()
        const lastDayOfMonth = new Date(year, month + 1, 0).getDate() // ?
        for (let i = 1; i <= lastDayOfMonth; i++) {
          kboDateList.push(new KboDate(year, month, i))
        }
        this.dateList = kboDateList
      },
      goWeek (e) {
        this.swiper.detachEvents()
        const isPrevButton = e.target.classList.contains('swiper-button-prev')
        const isNextButton = e.target.classList.contains('swiper-button-next')
        const currentIndex = this.swiper.previousIndex
        if (isPrevButton) {
          const prevWeek = currentIndex - 7
          this.swiper.slideTo(prevWeek < 0 ? 0 : prevWeek)
        }
        if (isNextButton) {
          const nextWeek = currentIndex + 7
          this.swiper.slideTo(nextWeek > this.dateList.length ? this.dateList.length : nextWeek)
        }
        this.swiper.attachEvents()
      },
      setDateFocus () {
        const { date } = this.currentDate.toObject()
        this.$nextTick(() => {
          this.$refs.dateListSwiper.swiper.slideTo(date - 1, 0)
        })
      },
      setDate (kboDate) {
        this.$nextTick(() => {
          this.changeFn(kboDate)
        })
      },
      clickDate () {
        const swiper = this.$refs.dateListSwiper.swiper
        this.$refs.dateListSwiper.swiper.slideTo(swiper.clickedIndex, 300)
      }
    },
    computed: {
      swiper () {
        return this.$refs.dateListSwiper.swiper
      }
    },
    created () {
      this.setDateListByMonth()
      this.setDateFocus()
    },
    mounted () {
      this.$nextTick(() => {
        this.$refs.dateListSwiper.swiper.on('transitionEnd', (swiper) => {
          if (swiper && swiper.activeIndex > -1) {
            this.setDate(this.dateList[swiper.activeIndex])
          }
        })
      })
    },
    beforeDestroy () {
      this.$refs.dateListSwiper.$destroy()
    },
    watch: {
      currentDate (newDate, oldDate) {
        if (newDate.getMonth() === oldDate.getMonth() && newDate.getFullYear() === oldDate.getFullYear()) {
          this.setDateFocus()
        } else {
          this.setDateListByMonth()
          this.setDateFocus()
        }
      }
    }
  }

</script>
